




















import {Component, Vue, Emit} from 'vue-property-decorator'

@Component({
    components: {},
})
export default class EditGhost extends Vue {
    private name: string = '失眠加绿'
    private mode: string = 'common'
    private img: string = ''
    private bg: string = ''
    private index: number = 0
    private editMode (v = 'edit') {
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollTop + 1)
            if (document.body.scrollTop >= 1) {
                window.scrollTo(0, document.body.scrollTop - 1)
            }
        }, 10)

        this.mode = v
        this.$nextTick(() => {
            const dom = document.querySelector('#name-input') as HTMLElement
            if (dom) {
                dom.focus()
            }
        })
    }
    @Emit('changeGhostName')
    private changeName () {
        // console.log(this.mode)
        // if (this.mode === 'common') {
        //     const dom = document.querySelector('.name-input')
        //     if (dom) {
        //         dom.blur()
        //     }
        //     return
        // }
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollTop + 1)
            if (document.body.scrollTop >= 1) {
                window.scrollTo(0, document.body.scrollTop - 1)
            }
        }, 10)
        return { index: this.index, name: this.name }
    }
    @Emit('removeGhost')
    private removeGhost () {
        this.mode = 'common'
        return this.index
    }
}
